<template>
  <iframe width="560" height="315" :src="`https://www.youtube.com/embed/${videoId}?modestbranding=1`" frameborder="0" 
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
    class="yt-modal"
  >
  </iframe>
</template>

<script>
export default {
  name: "VideoModalComponent",
  props: ['videoId']
}
</script>